import { Heading2, P, theme } from '@ovotech/element-v5';
import styled from 'styled-components';

export const StyledHeading = styled(Heading2)`
  color: ${theme.color.surface.onSurface};
  font-size: ${theme.font.size['3xl'].mediaQuery.lg};
`;

/** Copy can span several lines — newlines in the copy are rendered as breaks. */
export const StyledParagraph = styled(P)`
  white-space: pre-line;
`;
